import { PropsWithChildren, ReactNode } from "react"
import { Grid, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    cardGroup: {
        gap: "2rem",
    },
    cardGroupSubtitle: {
        color: theme.palette.tailwind.slate[400],
    },
    cardGroupCardArea: {
        gap: "2rem",
    },
    dashboard: {
        paddingTop: "4rem",
        gap: "4rem",
    },
    border: {
        paddingBottom: "0.5rem",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
}))

type DashboardCardGroupProps = Readonly<
    PropsWithChildren<{
        title?: string
        subtitle?: string
        titleRightContent?: ReactNode
    }>
>

export function DashboardCardGroup({ title, subtitle, children, titleRightContent }: DashboardCardGroupProps) {
    const { classes } = useStyles()

    return (
        <Grid container direction="column" wrap="nowrap" className={classes.cardGroup}>
            <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                className={titleRightContent ? classes.border : ""}
            >
                <Typography variant="h3">
                    {title}{" "}
                    {subtitle && (
                        <Typography display="inline" variant="h6" className={classes.cardGroupSubtitle}>
                            {subtitle}
                        </Typography>
                    )}
                </Typography>
                {titleRightContent}
            </Stack>
            <Grid container className={classes.cardGroupCardArea}>
                {children}
            </Grid>
        </Grid>
    )
}

type DashboardProps = Readonly<PropsWithChildren<{}>>

export function Dashboard({ children }: DashboardProps) {
    const { classes } = useStyles()

    return (
        <Grid container direction="column" wrap="nowrap" className={classes.dashboard}>
            {children}
        </Grid>
    )
}
